import ReportTracingAbilityBackward from '@/models/ReportTracingAbilityBackward/ReportTracingAbilityBackward';

export default class ReportTracingAbilityBackwardFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.filterControlCardId = '';
		this.filterPartNumber = '';
		this.filterWopNumber = '';
		this.filterLotNo = '';
		this.filterProdDateFrom = '';
		this.filterProdDateTo = '';
		this.filterFinishDateFrom = '';
		this.filterFinishDateTo = '';
		this.tempId = '';
		this.controlCardProduction = '';
		this.partNumberProduksi = '';
		this.materialSource = '';
		this.partNumberSource = '';
		this.lotNo = '';
		this.wopNumber = '';
		this.productionDate = '';
		this.finishProductionDate = '';
		this.controlCardRepair = '';
		this.controlCardCombineCase = '';
		this.controlCardFqQc = '';
		this.controlCardRepacking = '';
		this.changeFrom = '';
		this.machine = '';
		this.operatorUser = '';
		this.shift = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.qtyTaken = '';
		this.controlCardType = '';
		this.controlCardNumber = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			filterControlCardId: '0',
			filterPartNumber: '0',
			filterWopNumber: '0',
			filterLotNo: '0',
			filterProdDateFrom: '0',
			filterProdDateTo: '0',
			filterFinishDateFrom: '0',
			filterFinishDateTo: '0',
			tempId: '0',
			controlCardProduction: '0',
			partNumberProduksi: '0',
			materialSource: '0',
			partNumberSource: '0',
			lotNo: '0',
			wopNumber: '0',
			productionDate: '0',
			finishProductionDate: '0',
			controlCardRepair: '0',
			controlCardCombineCase: '0',
			controlCardFqQc: '0',
			controlCardRepacking: '0',
			changeFrom: '0',
			machine: '0',
			operatorUser: '0',
			shift: '0',
			qtyBefore: '0',
			qtyAfter: '0',
			qtyTaken: '0',
			controlCardType: '0',
			controlCardNumber: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}